import { gql } from '@apollo/client';
import { FRAGMENT_ACCESS_GROUP_WITH_ACCESS_CONTROLS } from './fragment.accessGroupWithAccessControls';

export const FETCH_ACCESS_GROUP_DETAILS = gql`
    ${FRAGMENT_ACCESS_GROUP_WITH_ACCESS_CONTROLS}
    query fetchAccessGroupDetails($accessGroupFilter: SystemAccessGroupFilter) {
        system {
            accessGroups(filter: $accessGroupFilter) {
                ...accessGroupWithAccessControls
            }
        }
    }
`;
